import { Box, Typography } from "@mui/material";
import { ChatBubbleOutline, LockOutlined } from "@mui/icons-material";
import { useIntl } from "react-intl";
import { PAGE_STATUS } from "../constants";

export default function SharedChatHeader({ dir, status, exchangeCount }) {
  const intl = useIntl();

  return (
    <header className="shared-chat-topbar">
      <Box className="shared-chat-brand">
        <Box className="shared-chat-brand-logo">
          <img src="/logo.png" alt="" />
        </Box>
        <Box className="shared-chat-brand-copy">
          <Typography className="shared-chat-brand-name">
            {intl.formatMessage({
              id: "chatbot.name",
              defaultMessage: "CAPMAS Assistant",
            })}
          </Typography>
          <Typography className="shared-chat-brand-hint">
            {intl.formatMessage({
              id: "chatbot.sharedPageSubtitle",
              defaultMessage:
                dir === "rtl"
                  ? "عرض لقطة من محادثة الجهاز المركزي للتعبئة العامة والإحصاء"
                  : "A snapshot of a CAPMAS assistant conversation",
            })}
          </Typography>
        </Box>
      </Box>

      <Box className="shared-chat-topbar-meta">
        <span className="shared-chat-pill shared-chat-pill--lock">
          <LockOutlined fontSize="inherit" />
          {intl.formatMessage({
            id: "chatbot.sharedReadOnlyBadge",
            defaultMessage: dir === "rtl" ? "للقراءة فقط" : "Read-only",
          })}
        </span>
        {status === PAGE_STATUS.SUCCESS && exchangeCount > 0 && (
          <span className="shared-chat-pill shared-chat-pill--count">
            <ChatBubbleOutline fontSize="inherit" />
            {intl.formatMessage(
              {
                id: "chatbot.sharedExchangeCount",
                defaultMessage:
                  dir === "rtl"
                    ? "{count} تبادل"
                    : "{count} exchange{plural}",
              },
              {
                count: exchangeCount,
                plural: exchangeCount === 1 ? "" : "s",
              },
            )}
          </span>
        )}
      </Box>
    </header>
  );
}
